var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user_placeholder"},[_c('div',{staticClass:"user_placeholder__avatar"}),_c('div',{staticClass:"user_placeholder__username"})])}]

export { render, staticRenderFns }